import { IntegrationConnectionResult } from '../models/IntegrationConnectionResult';

export class IntegrationConnectionResultMapper {
  mapGQLModel(data: any): IntegrationConnectionResult {
    return new IntegrationConnectionResult(data.isSuccessful, data.reason);
  }
}
